import { STTextAutonumberScheme } from '@tencent/slide-sdk-model';

// 编号 - sdk对上层类型映射
export const TEXT_AUTO_NUMBER_SCHEME_MAP = new Map([
    [STTextAutonumberScheme?.arabicPeriod, 'arabicPeriod'],
    [STTextAutonumberScheme?.arabicParenR, 'arabicParenR'],
    [STTextAutonumberScheme?.romanUcPeriod, 'romanUcPeriod'],
    [STTextAutonumberScheme?.romanLcPeriod, 'romanLcPeriod'],
    [STTextAutonumberScheme?.alphaUcPeriod, 'alphaUcPeriod'],
    [STTextAutonumberScheme?.alphaLcParenR, 'alphaLcParenR'],
    [STTextAutonumberScheme?.alphaLcPeriod, 'alphaLcPeriod'],
    [STTextAutonumberScheme?.ea1JpnChsDbPeriod, 'ea1JpnChsDbPeriod'],
    [STTextAutonumberScheme?.arabicParenBoth, 'arabicParenBoth'],
    [STTextAutonumberScheme?.circleNumDbPlain, 'circleNumDbPlain'],
    [STTextAutonumberScheme?.ea1ChsPeriod, 'ea1ChsPeriod'],
]);

// 从 office 中复制的编号类型和 sdk 编号类型的映射
export const OFFICE_COPY_NUMBER_TYPE_MAP = {
    3: STTextAutonumberScheme.arabicPeriod,
    18: STTextAutonumberScheme.circleNumDbPlain,
    7: STTextAutonumberScheme.romanUcPeriod,
    1: STTextAutonumberScheme.alphaUcPeriod,
    9: STTextAutonumberScheme.alphaLcParenR,
    0: STTextAutonumberScheme.alphaLcPeriod,
    38: STTextAutonumberScheme.ea1JpnChsDbPeriod,
};
